import axios from '@/api/axiosInstance';

export default async function getClassStudents(classId) {
  const response = await axios({
    method: 'get',
    url: `${process.env.NEXT_PUBLIC_API}/students`,
    params: {
      classId,
    },
  });
  return response.data;
}
